module.exports = __webpack_public_path__ + "static/media/homeBG2.1.c5b6f063.png";